if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();

        this.storage = localStorage.getItem('recently-viewed');
        this.store = this.storage !== null ? JSON.parse(this.storage) : {};

        /** @type {HTMLScriptElement | null} */
        this.data = this.querySelector('script[data-recently-viewed-json]');

        this.list = this.querySelector('[data-products-list]');

        /** @type {import('./types').ItemCarousel | null} */
        this.carousel = this.querySelector('item-carousel');
      }

      connectedCallback() {
        if (this.store && this.data && this.list) {
          const products = Object.values(this.store).reverse();

          if (products.length > 0) {
            this.list.innerHTML = '';

            products.forEach((product) => {
              const li = document.createElement('li');
              li.classList.add('swiper-slide');
              li.innerHTML = product;
              this.list?.append(li);
            });
          }

          if (this.carousel) {
            const instance = this.carousel.instance;

            if (instance) {
              instance.update();
            }
          }
        }
      }
    },
  );
}
